import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { supabase } from "../supabaseClient";
import "./Showrooms.css";

const ADMIN_EMAIL = "shaileshkamble771995@gmail.com";

export default function ShowroomAdminDashboard() {
  const { user } = useApp();
  const [showrooms, setShowrooms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await supabase.from("showrooms").select("*").order("created_at", { ascending: false });
      setShowrooms(data || []);
      setLoading(false);
    })();
  }, []);

  if (!user || user.email !== ADMIN_EMAIL) return <Navigate to="/" replace />;

  const updateRow = async (id, updates) => {
    await supabase.from("showrooms").update(updates).eq("id", id);
    setShowrooms((prev) => prev.map((row) => (row.id === id ? { ...row, ...updates } : row)));
  };

  return (
    <div className="showrooms-page">
      <div className="showrooms-hero">
        <div>
          <p className="showrooms-kicker">Showroom Admin</p>
          <h1>Approve, verify, premium, and suspend showroom listings</h1>
          <p>Use this dashboard to manage approval status and editorial trust on the public directory.</p>
        </div>
      </div>

      {loading ? (
        <div className="showrooms-state">Loading listings...</div>
      ) : (
        <div className="showrooms-grid">
          {showrooms.length === 0 ? (
            <div className="showrooms-state">No showroom listings available.</div>
          ) : (
            showrooms.map((showroom) => (
              <article key={showroom.id} className="showroom-card">
                <div className="showroom-card-body">
                  <h3>{showroom.showroom_name}</h3>
                  <p>{showroom.city}, {showroom.state}</p>
                  <p>Status: {showroom.status || "pending"} | Verified: {showroom.verified ? "yes" : "no"} | Premium: {showroom.premium ? "yes" : "no"}</p>
                  <div className="showroom-actions">
                    <button type="button" onClick={() => updateRow(showroom.id, { status: "approved" })}>Approve</button>
                    <button type="button" onClick={() => updateRow(showroom.id, { status: "rejected" })}>Reject</button>
                    <button type="button" onClick={() => updateRow(showroom.id, { verified: true })}>Verify</button>
                    <button type="button" onClick={() => updateRow(showroom.id, { premium: true })}>Make Premium</button>
                    <button type="button" onClick={() => updateRow(showroom.id, { status: "suspended" })}>Suspend</button>
                  </div>
                </div>
              </article>
            ))
          )}
        </div>
      )}
    </div>
  );
}
